import React from 'react';
import * as C from './styles';

export const LineTableCND = ({ name, validate, link }) => {
  return (
    <C.Container>
      <td>{name}</td>
      <td>{validate}</td>
      <td>
        <C.ButtonDownload href={link} target="_blank">
          Baixar
        </C.ButtonDownload>
      </td>
    </C.Container>
  );
};
